/**
 * Simple Popup Component JavaScript
 */
class SimplePopup {
  constructor(element) {
    this.element = element;
    this.overlay = this.element.querySelector('.simple-popup__overlay');
    this.closeButton = this.element.querySelector('.simple-popup__close');
    this.autoClose = parseInt(this.element.getAttribute('data-auto-close')) * 1000 || 0;
    this.popupId = this.element.id;
    
    this.isOpen = false;
    this.autoCloseTimer = null;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
    this.setupButtonTrigger();
  }
  
  bindEvents() {
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }
    
    // Overlay click to close
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }
    
    // Container click to close (clicking outside content)
    const container = this.element.querySelector('.simple-popup__container');
    if (container) {
      container.addEventListener('click', (e) => {
        if (e.target === container) {
          this.close();
        }
      });
    }
    
    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
    
    // Tab switching
    this.setupTabs();
    
    // Newsletter form submission
    const newsletterForm = this.element.querySelector('.simple-popup__newsletter-form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', () => {
        // Close popup after successful newsletter submission
        setTimeout(() => {
          if (this.element.querySelector('.simple-popup__success-message')) {
            setTimeout(() => this.close(), 2000);
          }
        }, 100);
      });
    }
  }
  
  setupButtonTrigger() {
    const trigger = document.querySelector(`[data-popup-trigger="${this.popupId}"]`);
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }
  }
  
  setupTabs() {
    const tabButtons = this.element.querySelectorAll('.simple-popup__tab-button');
    const tabPanels = this.element.querySelectorAll('.simple-popup__tab-panel');
    
    tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const targetTab = button.getAttribute('data-tab');
        
        // Remove active class from all buttons and panels
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabPanels.forEach(panel => panel.classList.remove('active'));
        
        // Add active class to clicked button and corresponding panel
        button.classList.add('active');
        const targetPanel = this.element.querySelector(`#${targetTab}`);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }
      });
    });
  }
  
  open() {
    if (this.isOpen) return;
    
    this.isOpen = true;
    this.element.classList.add('simple-popup--open');
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    
    // Setup auto-close timer
    if (this.autoClose > 0) {
      this.autoCloseTimer = setTimeout(() => this.close(), this.autoClose);
    }
    
    // Dispatch custom event
    this.element.dispatchEvent(new CustomEvent('popup:opened', {
      detail: { popup: this }
    }));
  }
  
  close() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.element.classList.remove('simple-popup--open');
    
    // Restore body scroll
    document.body.style.overflow = '';
    
    // Clear auto-close timer
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
    
    // Dispatch custom event
    this.element.dispatchEvent(new CustomEvent('popup:closed', {
      detail: { popup: this }
    }));
  }
  
  // Public methods
  forceOpen() {
    this.open();
  }
  
  forceClose() {
    this.close();
  }
}

// Initialize all popups when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const popups = document.querySelectorAll('.simple-popup');
  const popupInstances = [];
  
  popups.forEach(popup => {
    const instance = new SimplePopup(popup);
    popupInstances.push(instance);
  });
  
  // Make instances available globally for debugging
  window.simplePopups = popupInstances;
});

// Export for module use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = SimplePopup;
}